// axios响应拦截拦截器公用
import { Loading } from 'element-ui';
export const interceptorsResponse = {
  loading: () => {
    return Loading.service({
      lock: true,
      text: '加载中...',
      background: 'transparent',
      body: true,
    })
  },
  resolve: response => {
    const res = response.data
    if (!res || res.error_code !== 0) {
      return response//没有拦截错误状态的返回、看到有些业务组件里单独拿code做了处理
    } else {
      return response
    }
  },
  reject: error => {
    let resp = error.response
    if (resp.status === 404) {
      return Promise.reject(new Error('接口未找到'))
    }
    if (resp.status === 500) {
      return Promise.reject(new Error('服务端异常'))
    }
    return Promise.reject(error)
  }
}


// WEBPACK FOOTER //
// ./src/utils/interceptorsResponse.js